import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class ThemeService {
    private currentTheme: string = 'default-theme';
    private themeSubject = new BehaviorSubject<string>('orange-theme');
    private navbarSubject = new BehaviorSubject<string>(localStorage.getItem('token') != null ? 'navbar-active' : 'navbar-disable');
    theme$ = this.themeSubject.asObservable();
    navbar$ = this.navbarSubject.asObservable();
  
    getCurrentTheme(): string {
      return this.currentTheme;
    }
  
    setTheme(theme: string): void {
    //   this.currentTheme = theme;
    //   this.loadThemeStyles();
    this.themeSubject.next(theme);
    localStorage.setItem('themeName', theme);
    }

    setNavaBar(classCss: string): void {
      //   this.currentTheme = theme;
      //   this.loadThemeStyles();
      this.navbarSubject.next(classCss)
      }
  
    private loadThemeStyles(): void {
      const themeLink = document.querySelector('#theme-link') as HTMLLinkElement;
      themeLink.href = `./../themes/${this.currentTheme}.css`;
    }
  }